import React from 'react';

import { InfoModalContext } from './Context';

export const useInfoModal = (): ((title: string, content: React.ReactElement | string) => void) => {
  const context = React.useContext(InfoModalContext);

  if (!context) {
    return () => {
      throw Error('useInfoModal must be used within an InfoModalProvider');
    };
  }

  return context.showInfoModal;
};
